import { ExportType } from '../interfaces';
import { Values } from '../interfaces';
import { Filters, Refund } from './interfaces';

export enum RefundsActionType {
  GET_REFUNDS = 'REFUNDS/GET_REFUNDS',
  GET_REFUNDS_SUCCESS = 'REFUNDS/GET_REFUNDS_SUCCESS',
  GET_REFUNDS_ERROR = 'REFUNDS/GET_REFUNDS_ERROR',
  GET_BANKS = 'REFUNDS/GET_BANKS',
  GET_BANKS_SUCCESS = 'REFUNDS/GET_BANKS_SUCCESS',
  GET_BANKS_ERROR = 'REFUNDS/GET_BANKS_ERROR',
  REQUEST_REFUND = 'REFUNDS/REQUEST_REFUND',
  REQUEST_REFUND_SUCCESS = 'REFUNDS/REQUEST_REFUND_SUCCESS',
  REQUEST_REFUND_ERROR = 'REFUNDS/REQUEST_REFUND_ERROR',
  GET_PAYMENT_METHODS_FOR_REFUNDS = 'REFUNDS/GET_PAYMENT_METHODS_FOR_REFUNDS',
  GET_PAYMENT_METHODS_FOR_REFUNDS_SUCCESS = 'REFUNDS/GET_PAYMENT_METHODS_FOR_REFUNDS_SUCCESS',
  GET_PAYMENT_METHODS_FOR_REFUNDS_ERROR = 'REFUNDS/GET_PAYMENT_METHODS_FOR_REFUNDS_ERROR',
  SET_REFUND_DETAIL = 'REFUNDS/SET_REFUND_DETAIL',
  GET_REFUND_DETAIL = 'REFUNDS/GET_REFUND_DETAIL',
  GET_REFUND_DETAIL_SUCCESS = 'REFUNDS/GET_REFUND_DETAIL_SUCCESS',
  GET_REFUND_DETAIL_ERROR = 'REFUNDS/GET_REFUND_DETAIL_ERROR',
  EXPORT_REFUND_DETAIL = 'REFUNDS/EXPORT_REFUND_DETAIL',
  SHOW_EXPORT_REFUNDS = 'REFUNDS/SHOW_EXPORT_REFUNDS',
  EXPORT_REFUNDS = 'REFUNDS/EXPORT_REFUNDS',
  EXPORT_REFUNDS_SUCCESS = 'REFUNDS/EXPORT_REFUNDS_SUCCESS',
  EXPORT_REFUNDS_ERROR = 'REFUNDS/EXPORT_REFUNDS_ERROR',
}

export const getRefunds = (page?: number, filter?: Filters) => ({
  type: RefundsActionType.GET_REFUNDS,
  page,
  filter,
});

export const getRefundsSuccess = (response: any) => ({
  type: RefundsActionType.GET_REFUNDS_SUCCESS,
  response,
});

export const getRefundsError = (error: any) => ({
  type: RefundsActionType.GET_REFUNDS_ERROR,
  error,
});

export const getBanks = (country: string) => ({
  type: RefundsActionType.GET_BANKS,
  country,
});

export const getBanksSuccess = (response: any) => ({
  type: RefundsActionType.GET_BANKS_SUCCESS,
  response,
});

export const getBanksError = (error: any) => ({
  type: RefundsActionType.GET_BANKS_ERROR,
  error,
});

export const sendRequestRefund = (values: Values) => ({
  type: RefundsActionType.REQUEST_REFUND,
  values,
});

export const sendRequestRefundSuccess = (response: any) => ({
  type: RefundsActionType.REQUEST_REFUND_SUCCESS,
  response,
});

export const sendRequestRefundError = (error: any) => ({
  type: RefundsActionType.REQUEST_REFUND_ERROR,
  error,
});

export const getPaymentMethodsForRefunds = (country: string) => ({
  type: RefundsActionType.GET_PAYMENT_METHODS_FOR_REFUNDS,
  country,
});

export const getPaymentMethodsForRefundsSuccess = (response: any) => ({
  type: RefundsActionType.GET_PAYMENT_METHODS_FOR_REFUNDS_SUCCESS,
  response,
});

export const getPaymentMethodsForRefundsError = (error: any) => ({
  type: RefundsActionType.GET_PAYMENT_METHODS_FOR_REFUNDS_ERROR,
  error,
});

export const setRefundDetail = (data: Refund) => ({
  type: RefundsActionType.SET_REFUND_DETAIL,
  data,
});

export const getRefundDetail = (id: number) => ({
  type: RefundsActionType.GET_REFUND_DETAIL,
  id,
});

export const getRefundDetailSuccess = (response: any) => ({
  type: RefundsActionType.GET_REFUND_DETAIL_SUCCESS,
  response,
});

export const getRefundDetailError = (error: any) => ({
  type: RefundsActionType.GET_REFUND_DETAIL_ERROR,
  error,
});

export const exportRefundDetail = (id: number) => ({
  type: RefundsActionType.EXPORT_REFUND_DETAIL,
  id,
});

export const showExportRefunds = (show: boolean) => ({
  type: RefundsActionType.SHOW_EXPORT_REFUNDS,
  show,
});

export const exportRefunds = (filter: string, type: ExportType) => ({
  type: RefundsActionType.EXPORT_REFUNDS,
  filter,
  exportType: type,
});

export const exportRefundsSuccess = (response: any) => ({
  type: RefundsActionType.EXPORT_REFUNDS_SUCCESS,
  response,
});

export const exportRefundsError = (error: any) => ({
  type: RefundsActionType.EXPORT_REFUNDS_ERROR,
  error,
});
